import React, { FC, useState, useEffect } from "react";
import useFetch from "hooks/useFetch"; // Asegúrate de importar tu hook useFetch correctamente
import config from "config.json";
import StayDatesRangeInputView from "containers/ListingDetailPage/listing-stay-detail/StayDatesRangeInputView";
import GuestsInputView from "containers/ListingDetailPage/listing-stay-detail/GuestsInputView";
import { useNavigate } from "react-router-dom";
import SectionHotelData from "containers/ListingDetailPage/(components)/SectionHotelData";
import SectionGuestDistribution from "containers/ListingDetailPage/(components)/SectionGuestDistribution";

interface CheckOutPagePageMainProps {
  className?: string;
}

interface Habitacion {
  cantidad_ocupantes: number;
  codigo_habitacion: string;
  descripcion_categoria: string;
  temporada: Temporada[];
  subtotal_habitacion: number;
  ocupantes: Ocupante[];
}

interface Temporada {
  id_temporada: number;
  descripcion_temporada: string;
  dias_temporada: number;
  condiciones: Condicion[];
  subtotal_temporada: number;
  total_temporada: number;
}

interface Condicion {
  codigo_condicion: string;
  descripcion_condicion: string;
  cantidad_ocupantes: number;
  base_personas_ocupadas: BasePersona[];
  subtotal: number;
}

interface BasePersona {
  base_por_persona: number;
  cant_personas_condicion: number;
  monto: number;
  subtotal: number;
}

interface Ocupante {
  id: number;
  dni: string;
  apellidoNombre: string;
  condicion: string;
  fechaNacimiento: string;
}
interface Occupant {
  codigo_habitacion: string;
  id: number;
  dni: string;
  apellido_nombre: string;
  condicion: string;
  fecha_nac: string;
}
interface PreferenceData {
  preference_code: string;
  monto_senia: string;
  titulo_prereserva: string
}

interface HotelImage {
  hotel_code: string;
  photos: string[];
}

interface HotelImageDataResponse {
  default_image: string;
  hoteles: HotelImage[];
}

const CheckOutPagePageMain: FC<CheckOutPagePageMainProps> = ({
  className = "",
}) => {
  const formatDate = (dateString?: string): string => {
    // Helper function to get the default date in YYYY-MM-DD format
    const getDefaultDate = (offsetDays: number = 0) => {
      const date = new Date();
      date.setDate(date.getDate() + offsetDays);
      return date.toISOString().split('T')[0];
    };

    // Retrieve dates from sessionStorage
    let startDisp = sessionStorage.getItem("start_disp");
    let endDisp = sessionStorage.getItem("end_disp");

    // Set default dates if they do not exist
    if (!startDisp) {
      startDisp = getDefaultDate(); // Today's date
      sessionStorage.setItem("start_disp", startDisp);
    }

    if (!endDisp) {
      endDisp = getDefaultDate(3); // Today's date plus 3 days
      sessionStorage.setItem("end_disp", endDisp);
    }

    // Use the provided dateString if available, otherwise use startDisp or endDisp
    const dateToFormat = dateString || startDisp || endDisp;

    // Function to parse date in MM/DD/YYYY format
    const parseMMDDYYYY = (date: string) => {
      const [month, day, year] = date.split('/').map(part => part.padStart(2, '0'));
      return new Date(`${year}-${month}-${day}`);
    };

    // Function to parse date in YYYY-MM-DD format
    const parseYYYYMMDD = (date: string) => {
      return new Date(date);
    };

    // Determine which format the input is in and parse accordingly
    let parsedDate: Date;
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateToFormat)) {
      // YYYY-MM-DD format
      parsedDate = parseYYYYMMDD(dateToFormat);
    } else if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateToFormat)) {
      // MM/DD/YYYY format with single-digit month or day
      parsedDate = parseMMDDYYYY(dateToFormat);
    } else {
      console.error('Formato de fecha no válido:', dateToFormat);
      return ''; // Return an empty string or handle as needed
    }

    // Check if the date is valid
    if (isNaN(parsedDate.getTime())) {
      console.error('Fecha no válida:', dateToFormat);
      return ''; // Return an empty string or handle as needed
    }

    return parsedDate.toISOString().split('T')[0];
  };

  const [occupants, setOccupants] = useState<Occupant[]>([]);
  const hotel_code = sessionStorage.getItem("selected_hotel");
  const access_token = sessionStorage.getItem("user_token");
  const guest = sessionStorage.getItem("guests_checkout");
  const dateFrom = formatDate(sessionStorage.getItem("start_disp") ?? '');
  const dateTo = formatDate(sessionStorage.getItem("end_disp") ?? '');
  const [totalGuests, setTotalGuests] = useState<string>("");
  const [hotelImage, setHotelImage] = useState<string>("");
  const [confirmacion, setConfirmacion] = useState<boolean>(false);
  const additionalInfo = sessionStorage.getItem('informacion_adicional_reserva')
    ? JSON.parse(sessionStorage.getItem('informacion_adicional_reserva') || "{}").informacion_adicional_habitaciones
    : { "informacion_adicional_habitaciones": "No hay información disponible" };
  const usuario = sessionStorage.getItem("user_id") || "";

  function isPagoCompleto(): boolean {
    const storedDate: string | null = sessionStorage.getItem('start_disp');

    if (!storedDate) {
      return false; // Default to false if no date is stored
    }

    const startDate = new Date(storedDate); // Convert string to Date
    const currentDate = new Date();

    if (isNaN(startDate.getTime())) {
      throw new Error("Invalid date format in sessionStorage."); // Handle invalid dates
    }

    const diffInTime = startDate.getTime() - currentDate.getTime();
    const diffInDays = diffInTime / (1000 * 60 * 60 * 24);

    return diffInDays <= 3;
  }

  const pagoCompleto = isPagoCompleto();

  const [preReservaPayload, setPreReservaPayload] = useState<any>(
    {
      es_confirmacion: confirmacion,
      hotel: hotel_code,
      desde: dateFrom,
      hasta: dateTo,
      ocupantes: JSON.parse(guest?.toString() || "[]"),
      informacion_adicional_habitaciones: additionalInfo,
      id_user: usuario,
      pago_total: isPagoCompleto()
    }
  );
  const [showPaymentForm, setShowPaymentForm] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [hotel, setHotel] = useState<any>(null);

  const [totalAPagar, setTotalAPagar] = useState<number>(0)
  const [cantidadNoches, setcantidadNoches] = useState<number | null>(null)



  // Estado para los datos mockeados
  const [datosMockeados, setDatosMockeados] = useState<any>(null);

  const { data: hotelImagesData, error: hotelImagesError, fetchData: fetchHotelImages } = useFetch<HotelImageDataResponse>(
    "GET",
    `${config.backend_url}/setia/hoteles/ver_todas_fotos`,
    { "Content-Type": "application/json" }
  );

  const { data, isLoading, error, fetchData } = useFetch(
    "GET",
    `${config.backend_url}/setia/hotel/detalle?codigo=${hotel_code}`,
    { "Content-Type": "application/json" }
  );

  const { data: dataPreReserva, isLoading: isLoadingPreReserva, error: errorPreReserva, fetchData: fetchDataPreReserva } = useFetch(
    "POST",
    `${config.backend_url}/setia/reservas/prereserva`,
    preReservaPayload,
    { "Content-Type": "application/json" }
  );
  const { data: preferenceData, isLoading: isLoadingPreference, error: errorPreference, fetchData: fetchPreferenceData } = useFetch<PreferenceData>(
    "POST",
    `${config.backend_url}/setia/reservas/prereserva`,
    preReservaPayload,
    { "Content-Type": "application/json" }
  );

  useEffect(() => {
    fetchHotelImages(); // Llama para obtener las imágenes
    fetchData(); // Llama para obtener los detalles del hotel
  }, []);

  useEffect(() => {
    if (hotelImagesData) {
      const hotelData = hotelImagesData.hoteles.find(
        (hotel) => hotel.hotel_code === hotel_code
      );

      if (hotelData) {
        setHotelImage(hotelData.photos[0]);
      } else {
        setHotelImage(hotelImagesData.default_image);
      }
    }
  }, [hotelImagesData]);

  const handlePaymentButtonClick = () => {
    setConfirmacion(true);
    setErrorMessage(null);
    fetchPreferenceData();
  };

  useEffect(() => {
    if (preferenceData && preferenceData.preference_code) {
      sessionStorage.setItem("id_preferencia", preferenceData.preference_code);
      sessionStorage.setItem("preference_amount", preferenceData.monto_senia);
      setShowPaymentForm(true);
    } else if (errorPreference) {
      setErrorMessage("Error al obtener el ID de preferencia de pago.");
    }
  }, [preferenceData, errorPreference]);
  useEffect(() => {
    const occupantsData = sessionStorage.getItem("guests_checkout");
    if (occupantsData) {
      setOccupants(JSON.parse(occupantsData));
    }

    sessionStorage.removeItem("id_preferencia");
    sessionStorage.removeItem("preference_amount");

    fetchData();
    fetchDataPreReserva();
  }, []);

  useEffect(() => {
    if (dataPreReserva) {
      setDatosMockeados(dataPreReserva);
    }
  }, [dataPreReserva]);

  useEffect(() => {
    if (data) {
      setHotel(data);
    }
  }, [data]);


  const renderRatesInfo = () => {
    if (!datosMockeados) {
      return null; // Evitar renderizar si no hay datos mockeados
    }

    // Calcular el total de noches
    const totalNoches = getDifferenceInDays(new Date(datosMockeados.fecha_inicio), new Date(datosMockeados.fecha_fin));
    sessionStorage.setItem("total_noches", totalNoches.toString());
    // Función para obtener la diferencia en días entre dos fechas
    function getDifferenceInDays(startDate: Date, endDate: Date) {
      const differenceInTime = endDate.getTime() - startDate.getTime();
      const differenceInDays = differenceInTime / (1000 * 3600 * 24); // Convertir a días
      return Math.round(differenceInDays); // Redondear al número entero más cercano
    }

    let totalReserva = 0;

    const mapConditions = (condicion: any) => {
      switch (condicion) {
        case 'Afiliado':
          return 'Afiliado';
        case 'Invitado Menor':
          return 'Invitado Menor';
        case 'Invitado Mayor':
          return 'Invitado Mayor';
        case 'Jubilado Setia':
          return 'Jubilado Setia';
        case 'Familiar Menor':
          return 'Afiliado Menor';
        case 'Plaza No Ocupada':
          return 'Plaza No Ocupada';
        default:
          return '-';
      }
    }

    if (!datosMockeados) {
      return null; // Evitar renderizar si no hay datos mockeados
    }

    function calcularSubtotalHabitaciones(habitaciones: Habitacion[]) {
      let totalSubtotal = 0;

      habitaciones.forEach(habitacion => {
        habitacion.temporada.forEach(temporada => {
          totalSubtotal += temporada.subtotal_temporada;
        });
      });

      sessionStorage.setItem("total_subtotal", String(totalSubtotal));

      return totalSubtotal;
    }


    return (
      <div className="w-full flex flex-col sm:rounded-2xl lg:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 px-0 sm:p-6 xl:p-8 overflow-auto">
        <div className="flex flex-col space-y-4">
          <h3 className="text-2xl font-semibold">Detalles de Tarifa</h3>
          <table className="min-w-full divide-y divide-gray-200 hidden md:table">
            <thead className="bg-gray-50">
              <tr className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                <th className="px-2 py-1 font-semibold">Habitación</th>
                <th className="px-0 py-1">Ocupantes</th>
                <th className="px-10 py-1">Condición</th>
                {/* <th className="px-10 py-1">Condición</th>
                <th className="px-0 py-1">Monto por Persona</th>
                <th className="px-0 py-1">Subtotal por Persona</th>
                <th className="px-0 py-1">Subtotal Habitación</th> */}

                <th className="px-10 py-1">Tarifa</th>
                <th className="px-0 py-1">Subtotal</th>
                <th className="px-0 py-1">Dias</th>
                <th className="px-0 py-1">Total</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {datosMockeados.habitaciones.map((Habitacion: Habitacion) =>
                Habitacion.temporada.flatMap((temporada: Temporada) =>
                  temporada.condiciones.map((condicion, index) => {
                    const temporadaPrecio = temporada.total_temporada;
                    // Calcular el subtotal total de la habitación
                    const subtotalHabitacion = Habitacion.subtotal_habitacion;

                    // Calcular el subtotal por persona según la condición
                    const subtotalPorPersona =
                      condicion.base_personas_ocupadas[0].monto *
                      condicion.cantidad_ocupantes;

                    // Acumular el subtotal de la habitación
                    totalReserva += subtotalPorPersona;

                    return (
                      <tr
                        key={`${Habitacion.codigo_habitacion}-${temporada.id_temporada}-${condicion.codigo_condicion}-${index}`}
                      >
                        {index === 0 && (
                          <td
                            className="px-2 py-2 text-center"
                            rowSpan={temporada.condiciones.length}
                          >
                            {Habitacion.codigo_habitacion}
                          </td>
                        )}
                        <td className="px-2 py-2 text-center">
                          {condicion.cantidad_ocupantes}
                        </td>
                        {/* <td className="px-2 py-2 text-center">
                          {mapConditions(condicion.descripcion_condicion)}
                        </td>
                        <td className="px-2 py-2 text-center">
                          {condicion.base_personas_ocupadas[0].monto.toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                          })}
                          
                        </td>
                        <td className="px-2 py-2 text-center">
                          {(condicion.base_personas_ocupadas[0].monto * totalNoches).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                          
                        </td>
                        {index === 0 && (
                          <td
                            className="px-2 py-2 text-center"
                            rowSpan={temporada.condiciones.length}
                          >
                            {subtotalHabitacion.toLocaleString('en-US', {
                              style: 'currency',
                              currency: 'USD',
                            })}
                            
                          </td>
                        )} */}
                        <td className="px-2 py-2 text-center">
                          {mapConditions(condicion.descripcion_condicion)}
                        </td>

                        <td className="px-2 py-2 text-center">{temporada.descripcion_temporada}</td>
                        <td className="px-2 py-2 text-center">
                          {condicion.base_personas_ocupadas[0].subtotal.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                        </td>
                        <td className="px-2 py-2 text-center">{temporada.dias_temporada}</td>
                        <td className="px-2 py-2 text-center">{(condicion.base_personas_ocupadas[0].subtotal * temporada.dias_temporada).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</td>
                      </tr>
                    );
                  })
                )
              )}
            </tbody>
          </table>

          {/* Tarjetas para dispositivos móviles */}
          <div className="block md:hidden">
            {datosMockeados.habitaciones.map((Habitacion: Habitacion) =>
              Habitacion.temporada.flatMap((temporada: Temporada) =>
                temporada.condiciones.map((condicion, index) => {
                  const subtotalHabitacion = Habitacion.subtotal_habitacion;
                  const subtotalPorPersona =
                    condicion.base_personas_ocupadas[0].monto *
                    condicion.cantidad_ocupantes;
                  totalReserva += subtotalPorPersona;
                  return (
                    <div
                      key={`${Habitacion.codigo_habitacion}-${temporada.id_temporada}-${condicion.codigo_condicion}-${index}`}
                      className="border border-gray-200 mb-4 p-4 rounded-lg"
                    >
                      {index === 0 && (
                        <div className="font-semibold mb-2">Habitación: {Habitacion.codigo_habitacion}</div>
                      )}
                      <div className="mb-2">
                        <div className="font-semibold">Cantidad de Ocupantes:</div>
                        {condicion.cantidad_ocupantes}
                      </div>
                      <div className="mb-2">
                        <div className="font-semibold">Condición:</div>
                        {mapConditions(condicion.descripcion_condicion)}
                      </div>
                      <div className="mb-2">
                        <div className="font-semibold">Monto por Persona:</div>
                        {condicion.base_personas_ocupadas[0].monto.toLocaleString('en-US', {
                          style: 'currency',
                          currency: 'USD',
                        })}
                      </div>
                      <div className="mb-2">
                        <div className="font-semibold">Subtotal por Persona:</div>
                        {(condicion.base_personas_ocupadas[0].monto * totalNoches).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                      </div>
                      {index === 0 && (
                        <div>
                          <div className="font-semibold">Subtotal Habitación:</div>
                          {subtotalHabitacion.toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                          })}
                        </div>
                      )}
                    </div>
                  );
                })
              )
            )}
          </div>

          {/* Mostrar el total de la reserva */}
          <div className="flex flex-col justify-start items-start text-right mt-4">
            <p className="text-lg font-semibold pt-3 pl-3">
              {/* {calcularSubtotalHabitaciones(datosMockeados.habitaciones).toLocaleString('en-US', { style: 'currency', currency: 'USD' })} x {totalNoches.toLocaleString('en-US')} noches: {datosMockeados.total.toLocaleString('en-US', { style: 'currency', currency: 'USD' })} */}
              {"Precio"}: {totalNoches} noches = 
              {
                datosMockeados?.habitaciones?.reduce((acum: number, hab: Habitacion) => acum + hab?.subtotal_habitacion, 0)
                .toLocaleString('en-US', { style: 'currency', currency: 'USD' })
              }
            </p>

            <p className="text-lg font-semibold pt-3 pl-3">
              Descuento Afiliación: ${datosMockeados.descuento.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
            </p>

            <p className="text-lg font-semibold pt-3 pl-3">
              Total:  {datosMockeados?.total?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
            </p>
          </div>
        </div>
      </div>
    );
  };
  const router = useNavigate();

  const renderSidebar = () => {

    const handleViewPaymentPage = () => {
      router('/payment');
    };
    const hotelCode = sessionStorage.getItem("selected_hotel") || "";
    const subtotal = sessionStorage.getItem("total_subtotal") || "";
    const total_noches = sessionStorage.getItem("total_noches") || "";

    return (
      <div className="listingSectionSidebar__wrap shadow-xl">
        {/* PRICE */}
        <div className="flex justify-between">
          <span className="text-3xl font-semibold">
            Reserva:
            {/* <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
              /night
            </span> */}
          </span>
          {/* <StartRating /> */}
        </div>

        <SectionHotelData hotelCode={hotelCode} />
        {/* FORM */}
        <form className="flex flex-col border border-neutral-200 dark:border-neutral-700 rounded-3xl ">
          <StayDatesRangeInputView className="flex-1 z-[11]" />
          <div className="w-full border-b border-neutral-200 dark:border-neutral-700"></div>
          <GuestsInputView className="flex-1" />
          {/* datos de la distribucion de los huespedes */}
          <SectionGuestDistribution />

          {/* <h1 className="pl-4 pb-2 text-sm font-semibold">Precio : {(Number(subtotal)).toLocaleString('en-US', { style: 'currency', currency: 'USD' })} X {total_noches} noches = {(Number(subtotal) * Number(total_noches)).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</h1> */}
          <h1 className="pl-4 pb-2 text-sm font-semibold">Precio  : {total_noches} noches = {datosMockeados?.total?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</h1>
        </form>





        {/* SUBMIT */}
        
        <div className="space-y-4">
           <button onClick={handleViewPaymentPage} className={`w-full px-4 py-1.5 pb-3 bg-primary-500 text-white text-md sm:px-6 sm:py-2.5 rounded-full focus:outline-none selected`}>Pagar con Mercado Pago</button>
           {/* <button onClick={()=>{router('/transfer-payment')}} className={`w-full px-4 py-1.5 pb-3 bg-gray-500 text-white text-md sm:px-6 sm:py-2.5 rounded-full focus:outline-none selected`}>Pagar con Transferencia</button> */}
        </div>
      </div>
    );
  };

  const renderOccupantsTable = () => {

    const mapConditions = (condicion: any) => {

      switch (condicion) {
        case 'AFIL':
          return 'Afiliado';
        case 'IN-MEN':
          return 'Invitado Menor';
        case 'IN-MAY':
          return 'Invitado Mayor';
        case 'JUBIL':
          return 'Jubilado Setia';
        case 'FA-MEN':
          return 'Afiliado Menor';
        default:
          return '-';
      }
    }

    if (!datosMockeados) {
      return null; // Evitar renderizar si no hay datos mockeados
    }

    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8 overflow-auto">
        <h2 className="text-2xl font-semibold">Detalle de los Huéspedes</h2>
        <table className="min-w-full divide-y divide-gray-200 hidden md:table">
          <thead className="bg-gray-50">
            <tr className="text-primary-500">
              <th scope="col" className="px-6 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Nombre
              </th>
              <th scope="col" className="px-6 py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                DNI
              </th>
              <th scope="col" className="px-6 py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                Fecha de Nacimiento
              </th>
              <th scope="col" className="px-6 py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                Condición
              </th>
              <th scope="col" className="px-6 py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                Habitación
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {occupants.map((occupant, index) => (
              <tr key={index}>
                <td className="px-6 py-4 text-left whitespace-nowrap">{occupant.apellido_nombre}</td>
                <td className="px-6 py-4 text-center whitespace-nowrap">{occupant.dni}</td>
                <td className="px-6 py-4 text-center whitespace-nowrap">{occupant.fecha_nac}</td>
                <td className="px-6 py-4 text-center whitespace-nowrap">{mapConditions(occupant.condicion)}</td>
                <td className="px-6 py-4 text-center whitespace-nowrap">{occupant.codigo_habitacion}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Tarjetas para dispositivos móviles */}
        <div className="block md:hidden">
          {occupants.map((occupant, index) => (
            <div key={index} className="border border-gray-200 mb-4 p-4 rounded-lg">
              <div className="mb-2">
                <div className="font-semibold">Nombre:</div>
                {occupant.apellido_nombre}
              </div>
              <div className="mb-2">
                <div className="font-semibold">DNI:</div>
                {occupant.dni}
              </div>
              <div className="mb-2">
                <div className="font-semibold">Fecha de Nacimiento:</div>
                {occupant.fecha_nac}
              </div>
              <div className="mb-2">
                <div className="font-semibold">Condición:</div>
                {mapConditions(occupant.condicion)}
              </div>
              <div>
                <div className="font-semibold">Habitación:</div>
                {occupant.codigo_habitacion}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderPaymentWarning = () => {
    if (!datosMockeados) {
      return null; // Evitar renderizar si no hay datos mockeados
    }
    const handleViewPaymentPage = () => {
      router('/payment');
    };
    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
        <h2 className="text-2xl font-semibold">Confirmación de Reserva:</h2>
        {pagoCompleto ? (
          <p className="text-neutral-500 dark:text-neutral-400">
            Para confirmar la reserva, debes realizar el pago del 100% del total. <br />
            Para reservar la habitación, por favor realiza el pago de <span className="font-semibold text-black">{datosMockeados.monto_senia.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</span>
          </p>
        ) : (
          <p className="text-neutral-500 dark:text-neutral-400">
            Para confirmar la reserva, debes realizar el pago del 50% del total. <br />
            Una vez realizado el pago podras cancelar el saldo restante desde tu perfil.<br />
            Para reservar la habitación, por favor realiza el pago de <span className="font-semibold text-black">{datosMockeados.monto_senia.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</span>
          </p>
        )}

        <div>

          <button onClick={handleViewPaymentPage} className={`w-full lg:hidden px-4 py-1.5 pb-3 bg-primary-500 text-white text-md sm:px-6 sm:py-2.5 rounded-full focus:outline-none selected`}>Pagar con Mercado Pago</button>
          {/* <button onClick={()=>{router('/transfer-payment')}} className={`w-full lg:hidden px-4 py-1.5 pb-3 bg-primary-500 text-white text-md sm:px-6 sm:py-2.5 rounded-full focus:outline-none selected`}>Pagar con Transferencia</button> */}
        </div>
      </div>
    );
  };

  const renderMain = () => {
    const hotelCode = sessionStorage.getItem("selected_hotel") || "";
    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
        <h2 className="text-3xl lg:text-4xl font-semibold">
          Pago y Confirmación
        </h2>
        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
        <h2 className="text-2xl font-semibold">Tu viaje:</h2>
        <form className="flex flex-center border border-neutral-200 dark:border-neutral-700 rounded-3xl ">
          <StayDatesRangeInputView className="w-full" />
          <GuestsInputView className="w-full" />
        </form>
        <div className="space-y-8 lg:hidden">
          <h2 className="text-2xl font-semibold">Hotel:</h2>
          <SectionHotelData hotelCode={hotelCode} />
        </div>

        {renderOccupantsTable()}
        {renderRatesInfo()}
        {renderPaymentWarning()}
      </div>
    );
  };

  if (!hotel) {
    return null; // Evitar renderizar si no hay datos de hotel
  }

  return (
    <div className={`nc-CheckOutPagePageMain ${className}`}>
      <main className="container mt-11 mb-24 lg:mb-32 flex flex-col-reverse lg:flex-row overflow-hidden">
        <div className="w-full lg:w-3/5 xl:w-2/3 lg:pr-10">
          {renderMain()}
        </div>
        <div className="hidden lg:block flex-grow">
          {renderSidebar()}
        </div>
      </main>
    </div>
  );
};

export default CheckOutPagePageMain;